export default class Mutation {
  /**
   * @type {function}
   */
  #action;

  /**
   * @type {number}
   */
  #actionRepeatInterval = 0;

  /**
   * @type {number}
   */
  #mutationMinInterval = 0;

  /**
   * @type {number}
   */
  #mutationRepeatTimeout = 0;

  /**
   * @type {number}
   */
  #lastRefreshTime = 0;

  /**
   * @type {MutationObserver}
   */
  #mutation;

  /**
   * @param {function} action
   * @param {number} actionRepeatInterval
   * @param {number} mutationMinInterval
   */
  constructor(action, actionRepeatInterval, mutationMinInterval = 100) {
    this.#action = action;
    this.#actionRepeatInterval = actionRepeatInterval;
    this.#mutationMinInterval = mutationMinInterval;
    this.#mutation = new MutationObserver(() => this.#mutationCallback());
    this.#mutation.observe(
      document.body,
      {attributes: true, childList: true, subtree: true}
    );
  }

  /**
   *
   */
  stop() {
    if (this.#mutationRepeatTimeout) {
      clearTimeout(this.#mutationRepeatTimeout);
    }
    if (this.#mutation) {
      this.#mutation.disconnect();
    }
  }

  /**
   *
   */
  #mutationCallback() {
    if (this.#mutationRepeatTimeout) {
      clearTimeout(this.#mutationRepeatTimeout);
    }

    const currentTime = new Date().getTime();
    if ((currentTime - this.#lastRefreshTime) > this.#mutationMinInterval) {
      this.#lastRefreshTime = currentTime;
      this.#action();
    }

    this.#mutationRepeatTimeout = setTimeout(
      () => this.#mutationCallback(),
      this.#actionRepeatInterval
    );
  }
}